// **********************************************************
// Gallery Slider
// **********************************************************

const galleryMainSlider = document.querySelectorAll('[data-slider="gallery-main-slider"]');
const galleryThumbSlider = document.querySelectorAll('[data-slider="gallery-thumb-slider"]');

// *******************************************************************************
// 1.1 - Gallery Thumb Slider
// *******************************************************************************

const galleryThumbSliderOptions = {
  slidesPerView: 4,
  spaceBetween: 16,
  watchOverflow: true,
  centerInsufficientSlides: true,
  speed: 600,
  breakpoints: {
    767: {
      slidesPerView: 8,
      spaceBetween: 20,
    },
  },
};

galleryThumbSlider.forEach((el) => new Swiper(el, galleryThumbSliderOptions));

// *******************************************************************************
// 1.2 -Gallery Main Slider
// *******************************************************************************

const galleryMainSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 600,
  autoHeight: true,
  thumbs: {
    swiper: false,
  },
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
};

galleryMainSlider.forEach((el, i) => {
  const galleryMainSliderParent = el.closest('.gallery-module');
  const arrowRight = galleryMainSliderParent.querySelector('.arrow-right');
  const arrowLeft = galleryMainSliderParent.querySelector('.arrow-left');

  galleryMainSliderOptions.navigation.nextEl = arrowRight;
  galleryMainSliderOptions.navigation.prevEl = arrowLeft;

  galleryMainSliderOptions.thumbs.swiper = galleryThumbSlider[i].swiper;

  new Swiper(el, galleryMainSliderOptions);
});
